import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

const Tutorial = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="h5" mb={5} gutterBottom >
        آموزش اضافه کردن پروژه
      </Typography>

      {/* مرحله ۱ */}
      <Paper sx={{ p: 3, my: 2, backgroundColor: '#303B4B', color: 'white', height: '140px' }}>
        <Typography variant="h6" gutterBottom>مرحله ۱ : ایجاد API Key در ووکامرس</Typography>
        <Typography variant="body2" gutterBottom>
          وارد پیشخوان شوید . از قسمت پیکربندی ووکامرس {'>'} تب پیشرفته {'>'} REST API اقدام به ایجاد کلید نمایید . 
          <br />
          <Typography variant="body2" sx={{ mt: 1, color: '#aaa' }}>
            Settings {'>'} Advanced {'>'} REST API
          </Typography>
        </Typography>
      </Paper>

      {/* مرحله ۲ */}
      <Paper sx={{ p: 3, my: 2, backgroundColor: '#303B4B', color: 'white', height: '140px' }}>
        <Typography variant="h6" gutterBottom>مرحله ۲ : گرفتن consumer_key و consumer_secret</Typography>
        <Typography variant="body2">
          گزینه افزودن کلید رو انتخاب کنید و کلید را با دسرسی خواندن / نوشتن ایجاد کنید . بعد از ایجاد ، هر دو کلید رو کپی کنید .
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, color: '#aaa' }}>
          consumer_key_xxxxxxx و consumer_secret_yyyyyyy
        </Typography>
      </Paper>

      {/* مرحله ۳ */}
      <Paper sx={{ p: 3, my: 2, backgroundColor: '#303B4B', color: 'white', height: '140px' }}>
        <Typography variant="h6" gutterBottom>مرحله ۳: افزودن پروژه در برنامه</Typography>
        <Typography variant="body2" gutterBottom>
          به قسمت " افزودن پروژه " برید و تمام فیلدها رو پر کنید و روی " ثبت " کلیک کنید .
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, color: '#aaa' }}>
          فقط موارد معتبر با تست API Key قابل قبول هستند .
        </Typography>
      </Paper>

      {/* دکمه تایید */}
      {/* <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={() => navigate('/project/add-project')}
      >
        متوجه شدم، شروع کن
      </Button> */}
    </Box>
  );
};

export default Tutorial;